import { showOrHideElements } from "../dom/showOrHideElements";

function setMaterial(
	material: string,
	materialSpans: NodeListOf<HTMLSpanElement>,
	disable = false,
) {
	const materialSpan: HTMLSpanElement | undefined = Array.from(materialSpans).find((span) => {
		const dataValue = span.getAttribute("data-value");
		const matches =
			dataValue !== null && String(dataValue).toLowerCase() === String(material).toLowerCase();
		return matches;
	});

	if (materialSpan !== undefined) {
		showOrHideElements({
			elements: [materialSpan],
			show: !disable,
		});
	}
}

export default setMaterial;
